import React from 'react';
import { InfiniteScroll, Image, List, Button } from 'antd-mobile';
import { Link } from 'react-router-dom';
import { IArticle } from '../../objects/article/types';
import icon from '../../assets/image/groub.png';
import { useNavigate } from 'react-router-dom';

interface PopularGroupListProps {
  groups: IArticle[];
  header?: string;
  loadMore: (isRetry: boolean) => Promise<void>;
  hasMore?: boolean;
}

// 单个群聊项组件
export const PopularGroupItem: React.FC<IArticle> = ({
  cover,
  title,
  intro,
  price,
}) => {
  return (
    <Link to={'/group/123'}>
      <div className="popular-group bg-white p-3 flex items-center">
        <img
          src={cover || icon}
          className="w-16 h-16 rounded-xl object-cover"
          alt={title}
        />
        <div className="ml-3 flex-1">
          <div className="flex justify-between items-start">
            <h3 className="font-semibold">{title}</h3>
            {/* <span className={`${tagColor} text-xs px-2 py-1 rounded-full`}>
              {tagText}
            </span> */}
          </div>
          <p className="text-xs text-gray-500 mt-1">{intro}</p>
          <div className="flex items-center mt-1">
            <div className="flex -space-x-2"></div>
            {/* <span className="text-xs text-gray-500 ml-2">
              {memberCount} 成员
            </span> */}
            <span className="text-xs text-gray-400 ml-auto">{price}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

// export const PopularGroupList: React.FC<PopularGroupListProps> = ({
//   groups,
// }) => {
//   return (
//     <div className="space-y-4" id="popular-groups">
//       {groups.map((group, index) => (
//         <PopularGroupItem key={index} {...group} />
//       ))}
//     </div>
//   );
// };

export const PopularGroupList: React.FC<PopularGroupListProps> = ({
  groups,
  header,
  hasMore,
  loadMore,
}) => {
  const navigate = useNavigate();
  return (
    <div>
      <List header={header}>
        {groups.map((item) => (
          <List.Item
            onClick={() => {
              navigate(
                `/group/${item.id}?title=${encodeURIComponent(
                  item.title,
                )}&price=${item.price}`,
              );
            }}
            key={item.title}
            prefix={
              <Image
                src={item.cover}
                style={{ borderRadius: 6 }}
                fit="cover"
                width={40}
                height={40}
              />
            }
            extra={
              <Button color="warning" size="small">
                入群
              </Button>
            }
            description={item.intro}
          >
            {item.title}
          </List.Item>
        ))}
      </List>
      <InfiniteScroll loadMore={loadMore} hasMore={!!hasMore} />
    </div>
  );
};
